export const safeSlicing = (score) => {
    return score <= 15 ? 15 : score;
};

export const types = {
    s1: 'S1',
    s2: 'S2',
    s3: 'S3',
    s4: 'S4',
    cor: 'Cor'
};

export const getPositionX = (center, radius, angle) =>
    center + radius * Math.cos((Math.PI * angle) / 180);

export const getPositionY = (center, radius, angle) =>
    center + radius * Math.sin((Math.PI * angle) / 180);

export const rmScoreDecompositionAdaptor = (res) => [
    {
        id: types.s1,
        name: 'scenario1',
        label: 'S1',
        order: 1,
        score: res.s1Score,
        fill: '#678190',
        options: {
            title: 'Scenario 1',
            rank: `${res.s1Rank}`,
            totalRevenue: res.totalRevenue,
            negativeDelta: res.negativeDelta
        }
    },
    {
        id: types.s2,
        name: 'scenario2',
        label: 'S2',
        order: 2,
        score: res.s2Score,
        fill: '#549AB5',
        options: {
            title: 'Scenario 2',
            rank: `${res.s2Rank}`,
            crAlertRm: res.crAlertRm,
            crAlertPeer: res.crAlertPeer,
            prmAlertRm: res.prmAlertRm,
            prmAlertPeer: res.prmAlertPeer
        }
    },
    {
        id: types.s3,
        name: 'scenario3',
        label: 'S3',
        order: 3,
        score: res.s3Score,
        fill: '#A9B8C1',
        options: {
            title: 'Scenario 3',
            rank: `${res.s3Rank}`,
            eoTradesRm: res.eoTradesRm,
            eoTradesPeer: res.eoTradesPeer
        }
    },
    {
        id: types.s4,
        name: 'scenario4',
        label: 'S4',
        order: 4,
        score: res.s4Score,
        fill: '#7FADBF',
        options: {
            title: 'Scenario 4',
            rank: `${res.s4Rank}`,
            maxClient: res.maxClient
        }
    },
    {
        id: types.cor,
        name: 'correlation',
        label: 'Corr',
        order: 5,
        score: res.correlationScore,
        fill: '#9BCEE2',
        options: {
            title: 'Correlation',
            corrS1S2: res.corrS1S2,
            corrS1S3: res.corrS1S3,
            corrS1S4: res.corrS1S4,
            corrS2S3: res.corrS2S3,
            corrS2S4: res.corrS2S4,
            corrS3S4: res.corrS3S4
        }
    }
];

export const handleCorrPosition = (
    data,
    center,
    textRadius,
    angleStart,
    diffAngle,
    tx1,
    ty1
) => {
    const cDeg = Math.round(data.centerAngle);
    const c = center;
    const r = textRadius;
    const ags = angleStart;
    const dfa = diffAngle;

    if (cDeg <= 23) {
        tx1 = getPositionX(c, r, ags + dfa - 2.5);
        ty1 = getPositionY(c, r, ags + dfa - 3);
    } else if (cDeg <= 34) {
        tx1 = getPositionX(c, r, ags + dfa - 1.5);
        ty1 = getPositionY(c, r, ags + dfa - 3);
    } else if (cDeg <= 40) {
        tx1 = getPositionX(c, r, ags + dfa - 0.8);
        ty1 = getPositionY(c, r, ags + dfa - 3);
    } else if (cDeg >= 60 && cDeg <= 75) {
        tx1 = getPositionX(c, r, ags + dfa - 3.5);
        ty1 = getPositionY(c, r, ags + dfa + 1);
    } else if (cDeg > 75 && cDeg <= 90) {
        tx1 = getPositionX(c, r, ags + dfa - 20);
        ty1 = getPositionY(c, r, ags + dfa + 1.5);
    } else if (cDeg > 90 && cDeg <= 100) {
        tx1 = getPositionX(c, r, ags + dfa - 30);
        ty1 = getPositionY(c, r, ags + dfa + 1.5);
    } else if (cDeg > 100 && cDeg <= 220) {
        tx1 = getPositionX(c, r, ags + dfa + 2 + cDeg / 90);
        ty1 = getPositionY(c, r + cDeg / 35, ags + dfa + 3);
    } else if (cDeg > 220 && cDeg <= 275) {
        tx1 = getPositionX(c, r, ags + dfa + 2 + cDeg / 90);
        ty1 = getPositionY(c, r + cDeg / 100, ags + dfa);
    } else if (cDeg > 275 && cDeg <= 310) {
        tx1 = getPositionX(c, r + 5, ags + dfa);
        ty1 = getPositionY(c, r + cDeg / 100, ags + dfa - 4);
    } else if (cDeg > 310 && cDeg <= 325) {
        tx1 = getPositionX(c, r + 9, ags + dfa);
        ty1 = getPositionY(c, r, ags + dfa - 4);
    } else if (cDeg > 325 && cDeg <= 350) {
        tx1 = getPositionX(c, r + 9, ags + dfa - 1.5);
        ty1 = getPositionY(c, r, ags + dfa + 1);
    } else if (cDeg > 350 && cDeg <= 360) {
        tx1 = getPositionX(c, r + 9, ags + dfa - 2.8);
        ty1 = getPositionY(c, r, ags + dfa);
    }
    return { tx1, ty1 };
};
